module.exports = __webpack_public_path__ + "img/5.92afcb8b.png";